var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreateProjectActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "085A27FF-3952-4A3B-AE8D-74938DBE9CC8") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Create-Project",
    transform: "translate(-19.000000, -405.000000)",
    fill: "#035FB2",
    stroke: "#035FB2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(0.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30,405 C30.3944891,405 30.7142857,405.319797 30.7142857,405.714286 L30.714,414.714 L39.5,414.714286 C39.7761424,414.714286 40,414.938143 40,415.214286 C40,415.490428 39.7761424,415.714286 39.5,415.714286 L30.714,415.714 L30.7142857,424.285714 C30.7142857,424.680203 30.3944891,425 30,425 C29.6055109,425 29.2857143,424.680203 29.2857143,424.285714 L29.285,415.714 L20.5,415.714286 C20.2238576,415.714286 20,415.490428 20,415.214286 C20,414.938143 20.2238576,414.714286 20.5,414.714286 L29.285,414.714 L29.2857143,405.714286 C29.2857143,405.319797 29.6055109,405 30,405 Z",
    id: "create-project-active"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateProjectActive);
export default __webpack_public_path__ + "static/media/create-project-active.bfee01bde4571ca67163c236c80d3642.svg";
export { ForwardRef as ReactComponent };